import React, { Component, useRef, useState, useEffect } from 'react'
import { Container, Breadcrumbs, Link, Grid } from '@material-ui/core'
import { BoxSomeHeadersGLPure, ButtonHLPure, DialogSystemGLPure, SimpleLoading } from '../../pures'
import { DigitalVaultAlertsAction } from '../../actions'
import { useTranslation } from "react-i18next"
import DocumentPanelBarBasicData from './document-panel-bar-basic-data'
import DocumentPanelActions from './document-panel-actions'
import DocumentPanelBarVariables from './document-panel-bar-variables'
import DocumentPanelBarBinnacle from './document-panel-bar-binnacle'
import DocumentPDF from './document-pdf'
import './digital-vault-document.view.css'
import DocumentPanelBarVersions from './document-panel-bar-versions.view'
import DocumentPanelBarExpediente from './document-panel-bar-expediente.view'
import DocumentPanelBarTags from './document-panel-bar-tags'
import Asn1DataTable from "../../pures/asn1Render/Asn1Render"

const DigitalVaultDocumentView = (props) => {
    let {
        toggleCompletedRequesting,
        toggleErrorRequesting,
        toggleLoadingRequesting,
        isLoading,
        showLoadingRequesting,
        showErrorRequesting,
        showCompletedRequesting,
        messageError,
        breadcrumbItems,
        handleBreadcrumbClick,
        selectedCategory,
        subcategoryPath,
        setSelectedDocument,
        setSubcategoryPath,
        setSelectedCategory,
        documentData,
        showBasicInfo,
        formatTransaction,
        formatPenaltyFee,
        showActions,
        showPDF,
        showPanelVaribales,
        showPanelBinnacle,
        showPrincipalView,
        showEditView,
        handleShowPrincipalView,
        actionOptions,
        showVersions,
        showExpediente,
        fileType
    } = props

    const breadcrumbRef = useRef()
    const { t } = useTranslation()

    const [description, setDescription] = useState('')
    const [transaction, setTransaction] = useState('$0.0')
    const [monetaryUnit, setMonetaryUnit] = useState("")
    const [penaltyFee, setPenaltyFee] = useState(false)
    const [confidentialCheck, setConfidentialCheck] = useState(false)
    const [obligatoryCheck, setObligatoryCheck] = useState(false)
    const [variableSelected, setVariableSelected] = useState({})
    const [binnacleSelected, setBinnacleSelected] = useState({})
    const [showAlerts, setShowAlerts] = useState(false)
    const [tags, setTags] = useState([])

    useEffect(() => {
        if (!documentData && !documentData.tags) return
        setDescription(documentData.description)
        setConfidentialCheck(documentData.confidential)
        setObligatoryCheck(documentData.obligatory)
        setPenaltyFee(formatPenaltyFee)
        setTags(documentData.tags)
        setMonetaryUnit(documentData.monetaryUnit)
    }, [documentData])

    useEffect(() => {
        setTransaction(formatTransaction)
    }, [formatTransaction])


    const hanldeSubcategoryClick = (e) => {
        e.preventDefault()
        setSelectedDocument(null)
    }

    const handleChangeDescription = (e) => {
        let value = e.target.value
        setDescription(value)
    }

    const handleTransaction = (e) => {
        let value = e.target.value
        setTransaction(value)
    }

    const handleMonetaryUnit = (e) => setMonetaryUnit(e.target.value)

    const handlePenaltyFee = (e) => {
        let value = e.target.checked
        setPenaltyFee(value)
    }

    const onChangeCheckBoxConfidential = (e) => {
        let value = e.target.checked
        setConfidentialCheck(value)
    }

    const onChangeCheckBoxObligatory = (e) => {
        let value = e.target.checked
        setObligatoryCheck(value)
    }

    // const handleDeleteChipTag = (e) => {
    //     let value = e.target.props.value
    //     let copyTags = [...tags]
    //     let tagsFilter = copyTags.filter((tag) => tag.value !== value)
    //     setTags(tagsFilter)
    // }

    const handleShowAlerts = () => {
        setShowAlerts(true)
    }

    if (isLoading) return <SimpleLoading />

    return (
        <Container disableGutters className=''>
            {
                showAlerts ? (
                    <DigitalVaultAlertsAction
                        toggleCompletedRequesting={toggleCompletedRequesting}
                        toggleLoadingRequesting={toggleLoadingRequesting}
                        toggleErrorRequesting={toggleErrorRequesting}
                        documentIdProps={documentData.id}
                        goBack={() => setShowAlerts(false)}
                        t={t}
                    />
                ) : (
                    <Grid container spacing={2}>
                        {
                            breadcrumbItems &&
                            <Grid item xs={12} disableGutters>
                                <Breadcrumbs innerRef={breadcrumbRef} maxItems={4} itemsBeforeCollapse={2} itemsAfterCollapse={2} aria-label="Categorías">
                                    {
                                        breadcrumbItems.map((item, i) => <Link
                                            href="#"
                                            onClick={(e) => {
                                                setSelectedDocument(null)
                                                handleBreadcrumbClick(e, item)
                                            }}
                                            aria-current="page"
                                        >
                                            {item.title}
                                        </Link>)
                                    }
                                    {
                                        documentData && (
                                            <Link
                                                href="#"
                                                onClick={(e) => hanldeSubcategoryClick(e)}
                                                aria-current="page"
                                            >
                                                {documentData.name}
                                            </Link>
                                        )
                                    }
                                </Breadcrumbs>
                            </Grid>
                        }
                        <Grid
                            item
                            xs={12}
                            sm={12}
                            md={12}
                            lg={12}
                            disableGutters
                            spacing={2}
                        >
                            <BoxSomeHeadersGLPure
                                titleOne={t("digitalVaultDocumentView.name.document")}
                                subtitleOne={documentData.name}
                                titleTwo={t("digitalVaultDocumentView.alias.document")}
                                subtitleTwo={documentData.alias}
                                titleThree={t("digitalVaultDocumentView.owner.document")}
                                subtitleThree={documentData.nameUser}
                                titleFour={t("digitalVaultDocumentView.type.document")}
                                subtitleFour={documentData.typeDocument}
                                startFourTitle
                            />
                        </Grid>
                        {
                            showPrincipalView && (
                                <Grid
                                    item
                                    xs={12}
                                    sm={12}
                                    md={12}
                                    lg={12}
                                    disableGutters
                                    className='digitalVaultDocument-elemnts'
                                >

                                    <div className='digitalVaultDocument-panelBars'>
                                        {
                                            showBasicInfo && (
                                                <DocumentPanelBarBasicData
                                                    {...props}
                                                    handleChangeDescription={handleChangeDescription}
                                                    description={description}
                                                    tags={tags}
                                                    transaction={transaction}
                                                    handleTransaction={handleTransaction}
                                                    monetaryUnit={monetaryUnit}
                                                    handleMonetaryUnit={handleMonetaryUnit}
                                                    penaltyFee={penaltyFee}
                                                    handlePenaltyFee={handlePenaltyFee}
                                                    confidentialCheck={confidentialCheck}
                                                    obligatoryCheck={obligatoryCheck}
                                                    onChangeCheckBoxConfidential={onChangeCheckBoxConfidential}
                                                    onChangeCheckBoxObligatory={onChangeCheckBoxObligatory}
                                                // handleDeleteChipTag={handleDeleteChipTag}
                                                />
                                            )
                                        }
                                        {
                                            showExpediente && (
                                                <DocumentPanelBarExpediente
                                                    {...props}
                                                />
                                            )
                                        }
                                        {
                                            showVersions && (
                                                <DocumentPanelBarVersions
                                                    {...props}
                                                />
                                            )
                                        }
                                        {
                                            showPanelVaribales && (
                                                <DocumentPanelBarVariables
                                                    {...props}
                                                    setVariableSelected={setVariableSelected}
                                                />
                                            )
                                        }
                                        {
                                            showPanelBinnacle && (
                                                <DocumentPanelBarBinnacle
                                                    {...props}
                                                    setBinnacleSelected={setBinnacleSelected}
                                                />
                                            )
                                        }
                                    </div>
                                    <div className='digitalVaultDocument-pdf-actions'>

                                        {
                                            showActions && (
                                                <DocumentPanelActions
                                                    handleShowAlerts={handleShowAlerts}
                                                    {...props}
                                                />
                                            )
                                        }
                                        {
                                            showPDF && fileType === "pdf" && (
                                                <DocumentPDF
                                                    {...props}
                                                />
                                            )
                                        }
                                        {fileType === "video" &&
                                            <div className='documentPDF-container'>
                                                <video
                                                    disablePictureInPicture
                                                    disableRemotePlayback
                                                    controls
                                                    src={props.url}
                                                    width={"100%"}
                                                    height={"100%"} />
                                            </div>
                                        }
                                        {fileType === "image" &&
                                            <div className='documentPDF-container'>
                                                <img
                                                    src={props.url}
                                                    width={"100%"}
                                                    height={"100%"}
                                                />
                                            </div>
                                        }
                                        {fileType === process.env.REACT_APP_OCTET_STREAM_TYPE && (
                                            <Asn1DataTable data={props.asn1Decode} />
                                        )}


                                    </div>
                                    {props.goBack &&
                                        <div className='digitalVaultDocument-back'>
                                            <ButtonHLPure
                                                nameBtn={t("button.return")}
                                                onClickBtn={props.goBack}
                                            />
                                        </div>
                                    }
                                </Grid>
                            )
                        }
                        {
                            showEditView && (
                                <Grid
                                    container
                                    xs={12}
                                    sm={12}
                                    md={12}
                                    lg={12}
                                    disableGutters
                                    spacing={2}
                                    className='digitalVaultDocument-editView-elements'
                                >
                                    <ButtonHLPure
                                        nameBtn={t("button.return")}
                                        primary={false}
                                        onClickBtn={(e) => handleShowPrincipalView(e)}
                                    />
                                </Grid>
                            )
                        }
                    </Grid>
                )
            }
            <DialogSystemGLPure
                showLoadingRequesting={showLoadingRequesting}
                showCompletedRequesting={showCompletedRequesting}
                showErrorRequesting={showErrorRequesting}
                toggleLoadingRequesting={toggleLoadingRequesting}
                toggleCompletedRequesting={toggleCompletedRequesting}
                toggleErrorRequesting={toggleErrorRequesting}
                message={messageError}
            />
        </Container>

    )
}

export default DigitalVaultDocumentView